module.exports = require("/app/src/shared/middleware/index.js")